import React, {useEffect} from 'react';

function ParentAnchor({
    children,
    blockId,
    blockName,
    refs,
    ...props
}) {
    useEffect(() => {
        const pageHeight = window.innerHeight;
        const observerMargin = Math.floor(pageHeight / 2);
        const observerConfig = {
            root: null,
            rootMargin: `-${pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin}px 0px -${observerMargin}px 0px`,
            threshold: 0
        };
        
        const handleIntersection = function(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //Desk
                    var activeParent = document.querySelector('.active-parent');
                    if(typeof(activeParent) != 'undefined' && activeParent != null){
                        activeParent.classList.remove('active-parent');
                    }
                    var menuItem = document.querySelector('[data-parent="'+ entry.target.id +'"]');
                    if(typeof(menuItem) != 'undefined' && menuItem != null){
                        menuItem.classList.add('active-parent');
                    }

                    //Mob
                    var activeParentMob = document.querySelector('.active-item');
                    if(typeof(activeParentMob) != 'undefined' && activeParentMob != null){
                        activeParentMob.classList.remove('active-item');
                    }
                    var menuItemMob = document.querySelector('[data-section="'+ entry.target.id +'"]');
                    if(typeof(menuItemMob) != 'undefined' && menuItemMob != null){
                        menuItemMob.classList.add('active-item');
                    }
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection,observerConfig);

        observer.observe(refs[blockName].current);

        return () => observer.disconnect();
        
    }, [refs, blockName]);

    return (
        <section 
            id={blockId}
            ref={refs[blockName]}>
            {children}
        </section>
    );
}

export default ParentAnchor